import React from 'react';
import {
  Grid,
  Input,
  IconButton,
  Tooltip,
  Icon,
  DropDownMenu,
  Button,
} from '@prometheus/components';
import { useNavigate } from 'react-router-dom';

export const SearchInModulesComponent = () => {
  const navigate = useNavigate();
  const [query, setQuery] = React.useState('');
  const [module, setModule] = React.useState({
    id: 'vocabulary',
    name: 'in Vocabulary',
  });
  const clearForm = (event: React.MouseEvent): void => {
    event.preventDefault();
    if (query != null) {
      setQuery('');
    }
  };
  const onSubmit = (e: React.FormEvent) => {
    e?.preventDefault();
    navigate(`/${module.id}?fullSearch=${query}`);
  };
  return (
    <Grid item xs={12} container>
      <Grid item flexGrow={1} mr="-1px">
        <form onSubmit={onSubmit}>
          <Input
            fullWidth
            placeholder="Search..."
            size="large"
            value={query}
            onChange={(e: any) => setQuery(e.target.value)}
            type="text"
            name="search-input"
            sx={{
              minWidth: 170,
              height: 48,
              '.MuiInputBase-root.input-root': {
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
              },
            }}
            InputProps={{
              endAdornment: (
                <IconButton size="small" onClick={clearForm}>
                  <Tooltip text="Clear">
                    <Icon iconName="close" sx={{ fontSize: 14 }} />
                  </Tooltip>
                </IconButton>
              ),
            }}
          />
        </form>
      </Grid>
      <Grid item>
        <DropDownMenu
          options={[
            {
              id: 'vocabulary',
              name: 'in Vocabulary',
            },
            {
              id: 'study-manager',
              name: 'in Study Manager',
            },
            {
              id: 'workspace/cohorts',
              name: 'in Cohorts (Workspace)',
            },
            {
              id: 'workspace/analyses',
              name: 'in Analyses (Workspace)',
            },
            {
              id: 'workspace/concept-sets',
              name: 'in Concept Sets (Workspace)',
            },
            {
              id: 'data-catalog',
              name: 'in Data Catalog',
            },
            {
              id: 'library',
              name: 'in Artifacts library',
            },
          ]}
          onClick={(item: any) => setModule(item)}
          variant="outlined"
          title={module.name}
          name={module.name}
          closeOnSelect
          preventOverflow
          size="large"
          sx={{
            minWidth: 170,
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
            borderColor: '#c2cad2',
          }}
          endIcon={
            <Icon
              iconName="chevronSorting"
              sx={{ '&.MuiSvgIcon-root': { fontSize: 14 } }}
            />
          }
        />
      </Grid>
      <Grid item ml={1}>
        <Button
          variant="contained"
          color="success"
          size="large"
          onClick={onSubmit}
          endIcon={
            <Icon
              iconName="search"
              sx={{ '&.MuiSvgIcon-root': { fontSize: 14 } }}
            />
          }
        >
          Search
        </Button>
      </Grid>
    </Grid>
  );
};
